export const HEADER = 'Не нашли, что искали?';
export const SEARCH_PLACEHOLDER = 'Я ищу';
export const SEARCH_THEME = 'light';
export const SUBMIT_BUTTON_TEXT = 'Найти';
export const SUBMIT_BUTTON_VIEW = 'tertiary';
export const LINKS_ICONS = false;
export const LINKS_HEIGHT = 490;
export const LINKS_COLUMNS = [1, 0, 0];
